define('appkit/bind.helper',[
  'underscore',
  'backbone'
], function(_, Backbone) {

  var BindHelper = function(src, target) {
    this.src = src;
    this.target = target;
    this.bindings = [];
  };

  _.extend(BindHelper.prototype, Backbone.Events, {

    bind: function(src, target) {
      if (arguments.length < 2) {
        target = src;
      }

      this.listenTo(this.src, 'change:' + src, function() {
        if (this.src.has(src)) {
          this.target.set(target, this.src.get(src));
        } else {
          this.target.unset(target);
        }
      });

      this.bindings.push({
        src: src,
        target: target
      })

      return this;
    },

    bindAll: function(keys) {
      _.each(keys, function(key) {
        if (_.isString(key)) {
          key = { src: key, target: key };
        }
        this.bind(key.src, key.target);
      }, this);
      return this;
    },

    transfer: function() {
      for (var i = 0, len = this.bindings.length, item; i < len; i++) {
        item = this.bindings[i];
        if (this.src.has(item.src)) {
          this.target.set(item.target, this.src.get(item.src));
        } else {
          this.target.unset(item.target);
        }
      }
      return this;
    }

  });

  return BindHelper;
});

